import axios from 'axios';
import { request } from 'utils';
import SimpleCrypto from "simple-crypto-js"

// [YOMA] - [ID-50650] - (Collections to Approval Redirect Issue) - (21-11-2022)
const { REACT_APP_EID } = process.env;
const headerOutToken = { 'e-id': REACT_APP_EID };


export const login = (obj) => axios.post('v1/login', obj, { headers: headerOutToken }).then(res => res?.data?.data);
export const logout = () => axios.get('v1/logout', {
    // [YOMA] - [ID-50650] - (Collections to Approval Redirect Issue) - (21-11-2022)
    headers: {
        'e-id': REACT_APP_EID,
        token: localStorage.getItem("_ac"),
        'refresh-token': localStorage.getItem("_rc")
    }
}).then(res => res);

export const authenticate = () => request({ url: 'v1/authenticate', method: 'get' }).then(res => res);
export const getReferenceData = () => request({ url: `v1/referenceData`, method: 'get' }).then(res => res?.data?.data);

// general apis
export const getListing = (path, obj) => request({ url: `v1/${path}`, method: 'post', data: obj }).then(res => res);
export const create = (path, obj) => request({ url: `v1/${path}`, method: 'post', data: obj }).then(res => res).catch(err => err);
export const update = (path, obj) => request({ url: `v1/${path}`, method: 'put', data: obj }).then(res => res).catch(err => err);
export const status = (path, obj) => request({ url: `v1/${path}`, method: 'patch', data: obj }).then(res => res).catch(err => err);

// common apis
export const get = (path) => request({ url: `v1/${path}`, method: 'get' }).then(res => res).catch(err => err);
export const getRoles = (path) => request({ url: `v2/${path}`, method: 'get' }).then(res => res).catch(err => err);
export const post = (path, obj) => request({ url: `v1/${path}`, method: 'post', data: obj }).then(res => res).catch(err => err);

// decrypt data
export const decrypting = (data) => {
    if (localStorage.getItem('_sc')) {
        const _sc = localStorage.getItem('_sc');
        const simpleCrypto = new SimpleCrypto(_sc);
        try {
            const decrypt = data ? simpleCrypto.decrypt(data) : '';
            return decrypt
        } catch (error) {

        }
    } else {
        logout();
    }
}
